import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';

const Terms = () => (
  <LegalPageLayout title="Terms of Service" lastUpdated="August 2026">
    <p>
      By accessing or using WE R GAME, you agree to these Terms of Service. If you do not agree, do not use the platform.
    </p>

    <h2>Eligibility</h2>
    <p>
      You must be at least 18 years old (or the minimum legal age where you live) and not prohibited from using prediction
      or wagering-style services in your jurisdiction. You are responsible for compliance with local laws.
    </p>

    <h2>Platform modes</h2>
    <ul>
      <li>
        <strong>Free:</strong> Uses tickets or points. No USDC stake required for standard free predictions subject to
        daily limits and verification rules.
      </li>
      <li>
        <strong>Boost:</strong> Stake USDC into a prize pool. Payouts depend on market resolution and pool rules.
      </li>
      <li>
        <strong>Market:</strong> Trade outcome shares via an orderbook. Prices move with supply and demand subject to
        platform liquidity and risk controls.
      </li>
    </ul>

    <h2>Accounts and wallets</h2>
    <p>
      You must provide accurate information and keep credentials secure. Linking a wallet authorizes us to associate
      on-chain activity with your account. You are responsible for all activity under your account and linked wallets.
    </p>

    <h2>USDC, vault, and withdrawals</h2>
    <p>
      Market trading uses a platform trading vault on Base. Deposits, fills, and settlements may take time to confirm
      on-chain. Withdrawable balance equals on-chain vault USDC minus reserved amounts for open buy orders and pending
      settlement. We are not responsible for network congestion, user wallet errors, or incorrect addresses.
    </p>

    <h2>Jackpots and payouts</h2>
    <p>
      Jackpot and boost pool amounts, eligibility windows, and claim procedures are defined by platform rules and smart
      contracts. We may adjust promotional pools, fees, or eligibility criteria with notice where practicable.
    </p>

    <h2>Prohibited conduct</h2>
    <ul>
      <li>Multi-accounting, sybil attacks, collusion, or market manipulation.</li>
      <li>Exploiting bugs, bypassing limits, or using bots without authorization.</li>
      <li>Harassment, illegal content, or impersonation.</li>
      <li>Reverse engineering or disrupting platform infrastructure.</li>
    </ul>

    <h2>Market integrity</h2>
    <p>
      We operate automated liquidity and price controls to maintain orderly markets. Admin may pause markets, adjust
      reference odds, or cancel abusive orders. Displayed prices and orderbook depth may include system-provided
      liquidity.
    </p>

    <h2>Disclaimers</h2>
    <p>
      The platform is provided &quot;as is&quot; without warranties. Predictions and trades involve risk. Past performance
      does not guarantee future results. We do not provide financial, legal, or tax advice.
    </p>

    <h2>Limitation of liability</h2>
    <p>
      To the maximum extent permitted by law, WE R GAME and its operators are not liable for indirect, incidental, or
      consequential damages, or for losses arising from blockchain failures, user error, or unauthorized account access.
    </p>

    <h2>Changes and termination</h2>
    <p>
      We may update these Terms or suspend/terminate accounts that violate them. Continued use after changes constitutes
      acceptance of the updated Terms.
    </p>

    <h2>Governing law</h2>
    <p>
      These Terms are governed by the laws applicable to the operating entity of WE R GAME, without regard to conflict of
      law principles. Disputes shall be resolved in the courts or forums specified by the operator.
    </p>
  </LegalPageLayout>
);

export default Terms;
